import * as Yup from "yup";

export function initialValues() {
  return {
    title: "",
    message: "",
    type: "general",
    mode: "all",
    levelId: null,
    gradeId: null,
  };
}

export function validationSchema() {
  return Yup.object({
    title: Yup.string().required("El título es obligatorio"),
    message: Yup.string().required("El mensaje es obligatorio"),
    type: Yup.string().required("El tipo es obligatorio"),
    mode: Yup.string()
      .oneOf(["all", "level", "grade"], "Audiencia inválida")
      .required("La audiencia es obligatoria"),
    levelId: Yup.number()
      .typeError("Seleccione un nivel válido")
      .when("mode", {
        is: "level",
        then: (schema) => schema.required("Seleccione un nivel"),
        otherwise: (schema) => schema.nullable(),
      }),
    gradeId: Yup.number()
      .typeError("Seleccione un grado válido")
      .when("mode", {
        is: "grade",
        then: (schema) => schema.required("Seleccione un grado"),
        otherwise: (schema) => schema.nullable(),
      }),
  });
}
